import script from "./ServiceDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceDetails.vue?vue&type=script&setup=true&lang=js"

import "./ServiceDetails.vue?vue&type=style&index=0&id=30123bf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30123bf6"]])

export default __exports__